import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export default function SuggestedMySpace() {
  const [writings, setWritings] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSuggested = async () => {
      const q = query(
        collection(db, "myspace"),
        orderBy("createdAt", "desc"), // latest first
        limit(8) // only 8 boxes
      );

      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setWritings(data);
    };

    fetchSuggested();
  }, []);

  return (
    <div className="bg-white py-10">
      {/* Header */}
      <div className="max-w-6xl mx-auto mb-8">
        <h2 className="text-3xl font-bold text-center">
          Suggested from MySpace
        </h2>
      </div>

      {/* Grid: 4 per row, 2 rows */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 px-6">
        {writings.map((item) => (
          <div
            key={item.id}
            onClick={() => navigate(`/myspace/${item.id}`)}
            className="border border-black rounded-xl p-5 cursor-pointer hover:bg-gray-50 transition"
          >
            <h3 className="text-lg font-semibold mb-1 line-clamp-2">
              {item.title}
            </h3>

            <p className="text-xs mb-2">
              By <strong>{item.author}</strong>
            </p>

            <p className="text-sm text-gray-700 line-clamp-3">
              {item.short}
            </p>

            <span className="inline-block mt-3 text-xs font-semibold underline">
              Read more →
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
